import { render, staticRenderFns } from "./TrainersView.vue?vue&type=template&id=87dfe508&"
import script from "./TrainersView.vue?vue&type=script&lang=js&"
export * from "./TrainersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports